module.exports = __webpack_public_path__ + "img/bohrungen-1_zzz.5d267b88.jpg";